import { FC } from "react";
import { ProButton } from '../../../antd';
import ButtonGroup from '../../../ButtonGroup';
import classNames from "classnames";
import { ScanPageRightOperationProps, ScanPageRightItemEnum, } from "../../interface";

const Operation: FC<ScanPageRightOperationProps> = props => {
  const { className, style, viewButtonGroupProps, optionButtonGroupProps, onClick, children, } = props;
  const classes = classNames('body-right-operation', className);
  return (
    <div className={classes} style={style}>
      <div className="body-right-operation-btns">
        {
          !!viewButtonGroupProps && (
            <ButtonGroup
              onClick={onClick}
              {...viewButtonGroupProps}
            />
          )
        }
        {
          !!optionButtonGroupProps && (
            <ButtonGroup
              onClick={onClick}
              {...optionButtonGroupProps}
            />
          )
        }
      </div>
      
      {children}
    </div>
  );
};

Operation.displayName = ScanPageRightItemEnum.RightOperation;

export default Operation;
